import type { WorkOrderStatusEnum } from 'gql/graphql';
import {
    getWorkOrderStatusLabel,
    getWorkOrderStatusColor,
} from 'pages/Project/UerProject/WorkOrder/workOrderConstants';
import type { BadgePropSize, BadgePropStatus } from 'uikit';
import { Badge } from 'uikit';

import './BadgeWorkOrderStatus.css';

interface IBadgeWorkOrderStatusProps {
    status: WorkOrderStatusEnum;
    size: BadgePropSize;
    style?: React.CSSProperties;
    as?: keyof JSX.IntrinsicElements;
}

export const BadgeWorkOrderStatus = ({ status, style = { marginRight: 8 }, ...props }: IBadgeWorkOrderStatusProps) =>
    status && (
        <Badge
            minified
            label={getWorkOrderStatusLabel(status)}
            status={getWorkOrderStatusColor(status) as BadgePropStatus}
            className={getWorkOrderStatusColor(status) === 'progress' ? 'BadgeColor_progress' : undefined}
            style={style}
            {...props}
        />
    );

BadgeWorkOrderStatus.displayName = 'BadgeWorkOrderStatus';
